import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { selectAllElements } from "../../../../actions";
import CheckmarkIcon from "../../../Layout/Icons/CheckmarkIcon";

class SelectAll extends React.Component {
  state = {
    selected: false,
  };

  handleClick = () => {
    this.props.selectAllElements(!this.state.selected);
    this.setState((prevState) => {
      return { selected: !prevState.selected };
    });
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    // Deselect the Select All button if not every element is selected
    if (
      nextProps.totalDeselectedElements !== this.props.totalDeselectedElements
    ) {
      if (nextProps.totalDeselectedElements >= 0 && this.state.selected) {
        this.setState({ selected: false });
      }
    }
  }

  render() {
    const selected = this.state.selected ? "selected" : "";

    return (
      <div className="control__container">
        <div className="control__title">Select All {this.state.selected}</div>
        <button
          className={`control__button button--border button button--canvas button--select-all ${selected}`}
          onClick={this.handleClick}
        >
          {this.state.selected && <CheckmarkIcon />}
        </button>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    layers: state.design.present.layer_set,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      selectAllElements,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectAll);
